import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Button } from 'components/Button'
import { ChargeDataTable } from './ChargeDataTable'
import ChargeDataFilter from './ChargeDataFilter'

import {
  chargeDataLogsSelectors,
  chargeDataLogsActions
} from 'store/ChargeDataLogs'

import { useTranslation } from 'react-i18next'

import * as S from './styled'
import { FileUpload } from 'components/FileUpload'
import { InputSelect, Pagination } from 'components'
import { ValidationErrorDisplay } from './ValidationErrorDisplay'

const INITIAL_FILE = {
  src: '',
  filename: ''
}

export function ChargeDataList() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { logs, uploadStatus } = useSelector(chargeDataLogsSelectors.all)

  // Estado para o arquivo
  const [fileObj, setFileObj] = useState(INITIAL_FILE)
  const [file, setFile] = useState(null)

  // Busca os logs ao carregar o componente
  useEffect(() => {
    dispatch(chargeDataLogsActions.fetchAll())
  }, [dispatch])

  // Manipulação de arquivo
  const handleLoadFile = (acceptedFiles: File[]) => {
    if (!acceptedFiles || acceptedFiles.length === 0) return

    dispatch(chargeDataLogsActions.clearUploadStatus())

    const file = acceptedFiles[0] as File
    setFile(file)
    setFileObj({
      src: URL.createObjectURL(file),
      filename: file.name
    })
  }

  const sendFile = () => {
    if (!file) return

    dispatch(chargeDataLogsActions.clearUploadStatus())
    dispatch(chargeDataLogsActions.uploadFile(file))
    handleRemoveImage()
  }

  const handleRemoveImage = () => {
    setFileObj(INITIAL_FILE)
    setFile(null)
  }

  function onFilterPaginate(params = {}) {
    dispatch(chargeDataLogsActions.fetchAll(params))
  }

  return (
    <S.Wrapper container>
      <S.FullGrid item xs={12}>
        <S.GridHeader>
          <S.GridTitle item container xs={12}>
            <S.BoxTitle>{t('chargeData:title')}</S.BoxTitle>
            <S.BoxLine />
          </S.GridTitle>
        </S.GridHeader>
        <S.GridFilter container spacing={3}>
          <S.GridInput item sm={12} md={6} lg={6}>
            <FileUpload
              name="fileChargeData"
              file={fileObj}
              onLoadImage={handleLoadFile}
              onRemoveImage={handleRemoveImage}
              acceptTypes="sheets"
              variant="square"
              maxSize={20}
            />
          </S.GridInput>
          <S.GridInput item sm={12} md={6} lg={6}>
            <InputSelect
              fullWidth
              label={t('chargeData:methodName')}
              optionLabel="title"
              optionValue="value"
              options={[
                {
                  title: 'Movimentação',
                  value: 'movimentacao'
                }
              ]}
              value="movimentacao"
              disabled={true}
            />
          </S.GridInput>
          <S.GridButtons item sm={12} md={12} lg={12}>
            <Button
              variant="secondary"
              onClick={sendFile}
              size="medium"
              disabled={!fileObj.src}
            >
              <p>{t('chargeData:sendFile')}</p>
            </Button>
          </S.GridButtons>
        </S.GridFilter>

        {uploadStatus.status && (
          <S.StatusMessage status={uploadStatus.status}>
            <S.StatusTitle>{uploadStatus.message}</S.StatusTitle>
            <ValidationErrorDisplay errors={uploadStatus.errors} />
          </S.StatusMessage>
        )}

        <ChargeDataFilter />

        <S.GridTable>
          <ChargeDataTable rows={logs.items || []} />
          {logs.pagination?.total > 0 && (
            <Pagination
              filters={{
                limit: logs.pagination.limit,
                page: logs.pagination.page
              }}
              limit={logs.pagination.limit}
              page={logs.pagination.page}
              totalItems={logs.pagination.total}
              setFilter={onFilterPaginate}
            />
          )}
        </S.GridTable>
      </S.FullGrid>
    </S.Wrapper>
  )
}
